export default __webpack_public_path__ + "static/media/Roboto-Regular.9d43b864.woff2";